import React from 'react';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { useTranslation } from 'react-i18next';

import Text from '../global/Text';
import fontMaker from '../../utils/font';
import { colors } from '../../constants/theme';
import { IS_SHORT_VIEWPORT } from '../../utils/screensize';
import type { ScheduleToggleMode } from '../../typing/scheduleItem';

interface ScheduleToggleProps {
  activeToggle: ScheduleToggleMode;
  onToggle: (toggle: ScheduleToggleMode) => void;
  primaryLabel?: string;
}

const ScheduleToggle: React.FC<ScheduleToggleProps> = ({ activeToggle, onToggle, primaryLabel }) => {
  const { t } = useTranslation('home');

  return (
    <View style={styles.container}>
      <TouchableOpacity
        activeOpacity={0.8}
        style={[
          styles.button,
          styles.primaryButton,
          activeToggle === 'today' ? styles.activeButton : styles.inactiveButton
        ]}
        onPress={() => onToggle('today')}
      >
        <Text style={[styles.buttonText, activeToggle === 'today' ? styles.activeText : styles.inactiveText]}>
          {primaryLabel || t('newHome.today')}
        </Text>
      </TouchableOpacity>
      <TouchableOpacity
        activeOpacity={0.8}
        style={[styles.button, activeToggle === 'active' ? styles.activeButton : styles.inactiveButton]}
        onPress={() => onToggle('active')}
      >
        <Text style={[styles.buttonText, activeToggle === 'active' ? styles.activeText : styles.inactiveText]}>
          {t('newHome.activeSchedules')}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

export default React.memo(ScheduleToggle);

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    marginHorizontal: 16,
    marginBottom: IS_SHORT_VIEWPORT ? 8 : 16,
    padding: 4,
    borderRadius: 28,
    backgroundColor: '#fff',
    borderWidth: 0,
    borderColor: '#E2E8F0'
  },
  button: {
    flex: 1,
    minHeight: 48,
    paddingVertical: 10,
    borderRadius: 24,
    alignItems: 'center',
    justifyContent: 'center'
  },
  primaryButton: {
    marginRight: 20
  },
  activeButton: {
    backgroundColor: colors.primary
  },
  inactiveButton: {
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: colors.lightgray
  },
  buttonText: {
    ...fontMaker({ weight: 'SemiBold' }),
    fontSize: 14
  },
  activeText: {
    color: '#fff'
  },
  inactiveText: {
    color: colors.darkgray
  }
});
